import Line from './Line';
import Circle from './Circle';

export { Line, Circle };

export default {
  Line: Line,
  Circle: Circle
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-progress/es/index.js
// module id = 630
// module chunks = 0 1